module.exports = __webpack_public_path__ + "img/1.53181106.jpg";